import actions from './constants';

export const fetchCatalogue = (category, code) => ({
  type: actions.FETCH_CATALOGUE,
  category,
  code,
});

export const showCatalogue = (category, code, result) => ({
  type: actions.SHOW_CATALOGUE,
  category,
  code,
  result,
});

export const showCatalogueError = (category, code, error) => ({
  type: actions.SHOW_CATALOGUE_ERROR,
  category,
  code,
  error,
});

export const downloadDatasetCatalogue = (code) => ({
  type: actions.DOWNLOAD_CATALOGUE,
  code,
});

export const downloadDatasetCatalogueError = (code, error) => ({
  type: actions.DOWNLOAD_CATALOGUE_ERROR,
  code,
  error,
});
